module.exports = __webpack_public_path__ + "static/media/mail.d10a02f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mail.svg
// module id = 1013
// module chunks = 2